import type { UserInputValidationError } from '@tectonics/prs/validation';

const MIN_LENGTH = 3;
const MAX_LENGTH = 100;
// Thai vowels and tone marks are combining marks (\p{M}), not letters (\p{L}),
// so "สมศักดิ์" only matches when marks are allowed after the first letter.
// Names may contain apostrophes, hyphens and periods, and may not be padded with spaces.
const TH_NAME_PATTERN = /^\p{L}(?:[\p{L}\p{M} '.-]*[\p{L}\p{M}'.-])?$/u;

export function validateThaiCustomerName(customerNameValue: string): UserInputValidationError | undefined {
  const customerName = customerNameValue || '';

  if (!customerName.trim()) {
    return { id: 'empty' };
  }

  if (customerName.length < MIN_LENGTH) {
    return { id: 'min-length' };
  }

  if (customerName.length > MAX_LENGTH) {
    return { id: 'max-length' };
  }

  if (!TH_NAME_PATTERN.test(customerName)) {
    return { id: 'invalid-characters' };
  }

  return undefined;
}
